import React from 'react';
import BudgetTracker from '../components/BudgetTracker';

const BudgetTrackerPage = () => {
  return (
    <div className="budget-tracker-page">
      <BudgetTracker />
    </div>
  );
};

export default BudgetTrackerPage;
